import { useEffect } from "react";
import { useUi } from "@/lib/store";

export function useGlobalShortcuts(handlers: { onSearch(): void; onNewNote(): void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const mod = e.ctrlKey || e.metaKey;
      if (mod && !e.shiftKey && e.key.toLowerCase() === "k") {
        e.preventDefault();
        handlers.onSearch();
      } else if (e.altKey && !mod && e.key.toLowerCase() === "n") {
        e.preventDefault();
        handlers.onNewNote();
      } else if (mod && e.shiftKey && e.key.toLowerCase() === "f") {
        e.preventDefault();
        const s = useUi.getState();
        s.setFocusMode(!s.focusMode);
      } else if (e.altKey && !mod && e.key.toLowerCase() === "w") {
        e.preventDefault();
        const s = useUi.getState();
        const u = s.userId;
        const ws = u ? s.workspaceByUser[u] : undefined;
        const active = u && ws && !s.page ? s.tabsByUser[u]?.[ws]?.activeKey : null;
        if (active) s.closeTab(active);
      } else if (e.key === "Escape" && useUi.getState().focusMode && !document.querySelector("[role=dialog]")) {
        useUi.getState().setFocusMode(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handlers]);
}
